export const addNewUserParameterToShopifyLinkUrl = (url: string): string => {
  if (!url) {
    return url;
  }

  const newUserParameter = '&newUser=1';

  return `${url.replace(newUserParameter, '')}${newUserParameter}`;
};
